module.exports = __webpack_public_path__ + "images/icons_v2/document-filled-fd3ab0c7.svg";